import { Pipe, PipeTransform } from '@angular/core';
import { MenuItem } from '../../core/models/menu.model';

@Pipe({ name: 'menuFilter' })
export class MenuFilterPipe implements PipeTransform {
  transform(items: any[], query: string): MenuItem[] {
    if (!query) return items;
    const lower = query.toLowerCase();
    return items.filter((item) => item.name.toLowerCase().includes(lower));
  }
}
